import { render, staticRenderFns } from "./ChatWorkspace.vue?vue&type=template&id=4ccd204e&scoped=true"
import script from "./ChatWorkspace.vue?vue&type=script&lang=js"
export * from "./ChatWorkspace.vue?vue&type=script&lang=js"
import style0 from "./ChatWorkspace.vue?vue&type=style&index=0&id=4ccd204e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccd204e",
  null
  
)

export default component.exports